import {DocumentPaymentEntryDto} from "./document-payment-entry.dto";

export class DocumentPaymentDto {

  public readonly id!: string;
  public readonly completed!: boolean;
  public readonly amount!: number;
  public readonly balance!: number;
  public readonly entries: DocumentPaymentEntryDto[] = [];

  constructor(init?: Partial<DocumentPaymentDto> | undefined) {
    Object.assign(this, init);
    if (init?.entries) {
      this.entries = init.entries.map((i) => new DocumentPaymentEntryDto(i))
        .sort((i1, i2) => i1.date.getTime() - i2.date.getTime());
    } else {
      this.entries = [];
    }
  }
}
